import Vue from "vue";
import Router from "vue-router";
// import { checkLineUser } from '@/config/line-service'

import store from "@/store";

Vue.use(Router);

const rolePermission = {
  admin: ["Admin"],
};
const selectRolePermission = "admin";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // checkLineUser: checkLineUser,
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "",
      redirect: "login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      meta: { roleUser: rolePermission[selectRolePermission] },
      children: [
        {
          name: "login",
          path: "login",
          component: () => import("@/views/Login"),
          meta: { roleUser: [""] },
          beforeEnter: (to, from, next) => {
            window.localStorage.clear();
            next();
          },
        },
      ],
    },

    {
      path: "",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "rewardreport",
          path: "reward/report/:name/:id",
          component: () => import("@/views/AdminManager/RewardReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          name: "reward-report-code",
          path: "reward/report/code/:name/:id",
          component: () => import("@/views/AdminManager/RewardCodeReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          path: "shipment",
          component: () => import("@/views/AdminManager/Shipment"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Shipment",
          },
        },
        {
          path: "employee",
          component: () => import("@/views/AdminManager/Employee"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Employees",
          },
        },
        {
          name: "blog",
          path: "blog",
          component: () => import("@/views/AdminManager/Blog.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Blog",
          },
        },
        {
          path: "dashboard",
          component: () => import("@/views/AdminManager/Dashboard.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Dashboard",
          },
        },
      ],
    },
    {
      path: "/mission",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "campaign-list",
          path: "campaign",
          component: () => import("@/views/AdminManager/Campaign"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "campaign-dashboard",
          path: "campaign-dashboard/:id",
          component: () => import("@/views/AdminManager/CampaignDashboard"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-list",
          path: "mission",
          component: () => import("@/views/AdminManager/Mission"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          path: "mission/manage",
          name: "createMission",
          component: () => import("@/components/missions/CreateMission"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-import-detail",
          path: "mission/import/:id",
          component: () => import("@/views/AdminManager/MissionImport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionLuckyDraw",
          path: "mission/lucky/:id",
          component: () => import("@/views/AdminManager/MissionLuckyDraw"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionLuckySummary",
          path: "mission/summary/:id",
          component: () => import("@/views/AdminManager/SummaryCode"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreport",
          path: "mission/report/:name/:id",
          component: () => import("@/views/AdminManager/MissionReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-report-anonymous",
          path: "mission/report-anonymous/:name/:id",
          component: () =>
            import("@/views/AdminManager/MissionReportAnonymous"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionqr",
          path: "mission/qr-activity/:name/:id",
          component: () => import("@/views/AdminManager/MissionCheckInQr"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreportcheckin",
          path: "mission/report-checkin/:name/:id/:isCheckInOnly",
          component: () => import("@/views/AdminManager/MissionCheckInReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-report-checkin",
          path: "mission/report-checkin/:id/:name/:mission_id/:isCheckInOnly",
          component: () =>
            import("@/views/AdminManager/MissionCheckInQrReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreportexam",
          path:
            "mission/report-exam/:name/:id/:expectedNum/:expectedType/:totalPoint",
          component: () =>
            import("@/views/AdminManager/MissionReportComponents/Exam"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreportkahoot",
          path: "mission/report-kahoot/:name/:id",
          component: () =>
            import("@/views/AdminManager/MissionReportComponents/Kahoot"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "activity-kahoot",
          path: "activity-kahoot",
          component: () => import("@/views/AdminManager/ReportKahoot.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-ReportKahoot",
          },
        },
        {
          name: "kahoot-report",
          path: "activity-kahoot/report/:id/:name",
          component: () => import("@/views/AdminManager/KahootDetail.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-ReportKahoot",
          },
        },
        {
          name: "mission-dashboard",
          path: "mission/dashboard/:name/:id",
          component: () => import("@/views/AdminManager/MissionDashboard"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          path: "activity-approve",
          component: () => import("@/views/AdminManager/MissionApprove"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },

        {
          path: "category",
          component: () => import("@/views/AdminManager/Category.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-platform",
          path: "mission-platform/:id",
          component: () => import("@/views/AdminManager/MissionPlatform"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "mission-checkin-dashboard",
          path: "mission-checkin-dashboard/:id",
          component: () =>
            import("@/views/AdminManager/MissionCheckInDashboard"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreport-survey-summary",
          path: "mission/reports-survey-summary/:id",
          component: () =>
            import(
              "@/views/AdminManager/MissionReportComponents/SurveySummary"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreport-multi-upload",
          path: "mission/report-multi-upload/:id",
          component: () =>
            import("@/views/AdminManager/MissionReportComponents/MultiUpload"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
        {
          name: "missionreport-quest-tracking",
          path: "mission/report-quest-tracking/:id",
          component: () =>
            import(
              "@/views/AdminManager/MissionReportComponents/QuestTracking"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Campaign",
          },
        },
      ],
    },

    {
      path: "/reward",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "reward",
          component: () => import("@/views/AdminManager/Reward"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          path: "reward-category",
          component: () => import("@/views/AdminManager/RewardCategory"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          path: "partner-integrate",
          component: () =>
            import("@/views/AdminManager/Partner/RewardPartnerIntegrate"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          path: "reward-partner",
          component: () => import("@/views/AdminManager/RewardPartner"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
        {
          path: "reward-partner-dashboard",
          component: () =>
            import(
              "@/views/AdminManager/DashboardComponents/Rewards/RewardPartner"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Reward",
          },
        },
      ],
    },

    {
      path: "/point",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "point-type",
          component: () => import("@/views/AdminManager/Point/PointType"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-PointType",
          },
        },
        {
          path: "add-point",
          component: () => import("@/views/AdminManager/Point/AddPoint"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
          },
        },
      ],
    },
    {
      path: "/product-central",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "product-list",
          name: "product-list",
          component: () =>
            import("@/views/AdminManager/ProductCentral/Products.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Product",
          },
        },
        {
          path: "warranty-form-list",
          name: "warranty-form-list",
          component: () =>
            import("@/views/AdminManager/ProductCentral/WarrantyForm.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-WarrantyForm",
          },
        },
        {
          path: "warranty-form-list/schema/:id",
          name: "warranty-form-schema",
          component: () =>
            import(
              "@/views/AdminManager/ProductCentral/WarrantyFormDetail.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-WarrantyForm",
          },
        },
        {
          path: "warranty-registration-list",
          name: "warranty-registration-list",
          component: () =>
            import(
              "@/views/AdminManager/ProductCentral/WarrantyRegistrations.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-WarrantyRegistration",
          },
        },
      ],
    },
    {
      path: "/sale-crm",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "dashboard",
          component: () =>
            import("@/views/AdminManager/SaleCRM/DashboardSales.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM",
          },
        },
        {
          path: "dashboard/2",
          component: () =>
            import("@/views/AdminManager/SaleCRM/DashboardSales2.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM",
          },
        },
        {
          path: "dashboard/sales-rep-performance",
          component: () =>
            import(
              "@/views/AdminManager/SaleCRM/DashboardSalesRepPerformance.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM",
          },
        },
        {
          path: "customer-tracking",
          name: "customer-tracking",
          component: () =>
            import("@/views/AdminManager/SaleCRM/CustomerTracking.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-CustomerTracking",
          },
        },
        {
          path: "customer-tracking/detail/:employee_id",
          name: "customer-tracking-detail",
          component: () =>
            import("@/views/AdminManager/SaleCRM/CustomerTrackingDetail.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-CustomerTracking",
          },
        },
        {
          path: "customer-tracking/follow-up/:employee_id",
          name: "customer-tracking-follow-up",
          component: () =>
            import("@/views/AdminManager/SaleCRM/CustomerTrackingFollowUp.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-CustomerTracking",
          },
        },
        {
          path: "customer-tracking/my-calendar",
          name: "customer-tracking-my-calendar",
          component: () =>
            import(
              "@/views/AdminManager/SaleCRM/CustomerTrackingMyCalendar.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-CustomerTracking",
          },
        },
        {
          path: "tracking-list",
          name: "tracking-list",
          component: () =>
            import("@/views/AdminManager/SaleCRM/TrackingList.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-TrackingList",
          },
        },
        {
          path: "tracking-list/schema/:id",
          name: "tracking-schema",
          component: () =>
            import("@/views/AdminManager/SaleCRM/TrackingSchema.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-TrackingList",
          },
        },
        {
          path: "customer-service-sale",
          component: () =>
            import("@/views/AdminManager/SaleCRM/CustomerServiceSale.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-SaleCRM-Sales",
          },
        },
        {
          path: "customer-service-goal",
          component: () =>
            import("@/views/AdminManager/SaleCRM/CustomerServiceGoal.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            // permission: "Access-SaleCRM-Goal",
            permission: "Access-SaleCRM",
          },
        },
      ],
    },
    {
      path: "/commerce",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "partner-integrate",
          component: () =>
            import("@/views/AdminManager/Commerce/CommercePartnerIntegrate"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            // permission: "Access-Commerce",
          },
        },
        {
          path: "shop",
          name: "commerce-shop",
          component: () => import("@/views/AdminManager/Commerce/Shop.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            // permission: "Access-Commerce",
          },
        },
        {
          path: "transaction-order",
          name: "commerce-transaction-order",
          component: () =>
            import("@/views/AdminManager/Commerce/TransactionOrder.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            // permission: "Access-Commerce",
          },
        },
      ],
    },
    {
      path: "/people",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "user",
          component: () => import("@/views/AdminManager/UserAdmin"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Admins",
          },
        },
        {
          path: "account",
          component: () => import("@/views/AdminManager/Account.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
          },
        },
        {
          path: "brand",
          name: "brand",
          component: () => import("@/views/AdminManager/Brand.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Admins-Brand",
          },
        },
        {
          path: "branch",
          name: "branch",
          component: () => import("@/views/AdminManager/Branch.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Admins-Branch",
          },
        },
      ],
    },
    {
      path: "/setting",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "general-setting",
          component: () => import("@/views/AdminManager/Information.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-GeneralSetting",
          },
        },
        {
          path: "custom-page",
          component: () => import("@/views/AdminManager/CustomPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-CustomPage",
          },
        },

        {
          path: "register-list",
          name: "register",
          component: () => import("@/views/AdminManager/Register.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-RegisterList",
          },
        },
        {
          path: "register/manage",
          name: "register-create",
          component: () => import("@/components/campaign/SurveyCampaign.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-RegisterList",
          },
        },
        {
          path: "register/:id/:name",
          name: "register-user",
          component: () => import("@/views/AdminManager/RegisterUser.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-RegisterList",
          },
        },
        {
          path: "platform",
          component: () => import("@/views/AdminManager/LinkPlatform.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-RegisterList",
          },
        },
        {
          path: "banner",
          component: () => import("@/views/AdminManager/PublicRelations.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Banner",
          },
        },
        {
          path: "customer-level",
          component: () => import("@/views/AdminManager/CustomerLevel.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-CustomerLevel",
          },
        },
        {
          path: "translate",
          component: () => import("@/views/AdminManager/TranslateList.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Translation",
          },
        },
      ],
    },
    {
      path: "/report",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "nps-report",
          component: () => import("@/views/AdminManager/NpsReport.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Report",
          },
        },
        {
          path: "sms-usage",
          component: () => import("@/views/AdminManager/SMSUsage.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Report",
          },
        },
        {
          path: "otp-usage",
          component: () => import("@/views/AdminManager/OTPUsage.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Report",
          },
        },
        {
          path: "transaction-usage",
          component: () => import("@/views/AdminManager/TransactionUsage.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Report",
          },
        },
      ],
    },
    {
      path: "/microsite",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "templates",
          component: () =>
            import("@/views/AdminManager/Microsite/MicrositeTemplate"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "templates/market",
          component: () =>
            import("@/views/AdminManager/Microsite/TemplateMarket"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "templates/market/view/:id",
          component: () =>
            import("@/views/AdminManager/Microsite/TemplateMarketView"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "my-campaign",
          component: () => import("@/views/AdminManager/Microsite/MyCampaign"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "my-campaign/edit/:id",
          component: () =>
            import("@/views/AdminManager/Microsite/EditMicrosite"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/login",
          component: () => import("@/components/microsite/template/LoginPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/register",
          component: () =>
            import("@/components/microsite/template/RegisterPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/bill",
          component: () => import("@/components/microsite/template/BillPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/thankyou",
          component: () =>
            import("@/components/microsite/template/ThankYouPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/announcement",
          component: () =>
            import("@/components/microsite/template/AnnouncementPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/menu",
          component: () => import("@/components/microsite/template/MenuPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/history",
          component: () =>
            import("@/components/microsite/template/HistoryPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/code",
          component: () => import("@/components/microsite/template/CodePage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/topSpender",
          component: () =>
            import("@/components/microsite/template/TopSpenderPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/pause",
          component: () => import("@/components/microsite/template/PausePage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/end",
          component: () => import("@/components/microsite/template/EndPage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "edit/:id/game",
          component: () => import("@/components/microsite/template/GamePage"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "my-campaign/admin-report/:id",
          component: () => import("@/views/AdminManager/Microsite/AdminReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
        {
          path: "my-campaign/admin-dashboard/:id",
          component: () =>
            import("@/views/AdminManager/Microsite/AdminDashboard"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Microsite",
          },
        },
      ],
    },

    {
      path: "/notification",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "setting",
          component: () =>
            import("@/views/AdminManager/Notification/Setting.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification",
          },
        },
        {
          path: "user",
          component: () => import("@/views/AdminManager/Notification/User.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-EventUser",
          },
        },
        {
          path: "admin",
          component: () =>
            import("@/views/AdminManager/Notification/Admin.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification",
          },
        },
        {
          path: "report-admin",
          name: "notification-report-admin",
          component: () =>
            import("@/views/AdminManager/Notification/ReportAdmin.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ReportAdmin",
          },
        },
        {
          path: "report-admin/detail/:id",
          name: "notification-report-admin-detail",
          component: () =>
            import(
              "@/views/AdminManager/Notification/ReportAdminUserDetail.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ReportAdmin",
          },
        },
        {
          path: "report-user",
          name: "notification-report-user",
          component: () =>
            import("@/views/AdminManager/Notification/ReportUser.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ReportUser",
          },
        },
        {
          path: "report-user/detail/:id",
          name: "notification-report-user-detail",
          component: () =>
            import(
              "@/views/AdminManager/Notification/ReportAdminUserDetail.vue"
            ),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ReportUser",
          },
        },
        {
          path: "chat-center",
          name: "chat-center",
          component: () =>
            import("@/views/AdminManager/Notification/ChatCenter.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ChatCenter",
          },
        },
        {
          path: "chat-center/dashboard",
          name: "chat-dashboard",
          component: () =>
            import("@/views/AdminManager/Notification/Dashboard.vue"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Notification-ChatCenter",
          },
        },
      ],
    },
    {
      path: "/front-office",
      component: () => import("@/layouts/front-office-layout/Layout"),
      children: [
        {
          path: "menu",
          name: "front-office-menu",
          component: () => import("@/views/AdminManager/FrontOffice/Menu"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-FrontOffice",
          },
        },
        {
          path: "register",
          name: "front-office-register",
          component: () => import("@/views/AdminManager/FrontOffice/Register"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-FrontOffice",
          },
        },
        {
          path: "customer-search",
          name: "front-office-customer",
          component: () =>
            import("@/views/AdminManager/FrontOffice/ListCustomer"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-FrontOffice",
          },
        },
        {
          path: "customer-detail/:id",
          name: "front-office-customer-detail",
          component: () =>
            import("@/views/AdminManager/FrontOffice/CustomerDetail"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-FrontOffice",
          },
        },
      ],
    },

    {
      path: "/gamification",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "reward-admin",
          name: "gamification-reward-admin-list",
          component: () =>
            import("@/views/AdminManager/Gamification/RewardAdminList"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Reward",
          },
        },
        {
          path: "admin",
          name: "gamification-admin-list",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminList"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Admin",
          },
        },
        {
          path: "user",
          name: "gamification-user-list",
          component: () => import("@/views/AdminManager/Gamification/UserList"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-User",
          },
        },
        {
          path: "admin/create-internal/:id",
          name: "gamification-admin-create-internal",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminCreateInternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Admin",
          },
        },
        {
          path: "admin/create-external/:id",
          name: "gamification-admin-create-external",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminCreateExternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Admin",
          },
        },
        {
          path: "user/create-internal/:id",
          name: "gamification-user-create-internal",
          component: () =>
            import("@/views/AdminManager/Gamification/UserCreateInternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-User",
          },
        },
        {
          path: "user/create-external/:id",
          name: "gamification-user-create-external",
          component: () =>
            import("@/views/AdminManager/Gamification/UserCreateExternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-User",
          },
        },
        {
          path: "admin/report-internal/:id",
          name: "gamification-admin-report-internal",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminReportInternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Admin",
          },
        },
        {
          path: "user/report-internal/:id",
          name: "gamification-user-report-internal",
          component: () =>
            import("@/views/AdminManager/Gamification/UserReportInternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-User",
          },
        },
        {
          path: "reward-admin/report/:id",
          name: "reward-admin-report",
          component: () =>
            import("@/views/AdminManager/Gamification/RewardAdminReport"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification-Reward",
          },
        },
      ],
    },
    {
      path: "/gamification",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          path: "admin/display-internal/:id",
          name: "gamification-admin-display-internal",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminDisplayInternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification",
          },
        },
        {
          path: "admin/display-external/:id",
          name: "gamification-admin-display-external",
          component: () =>
            import("@/views/AdminManager/Gamification/AdminDisplayExternal"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
            permission: "Access-Gamification",
          },
        },
      ],
    },

    {
      path: "",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          path: "maintenance",
          name: "maintenance",
          component: () => import("@/views/Maintenance"),
          meta: { roleUser: [] },
          beforeEnter: (to, from, next) => {
            window.localStorage.clear();
            next();
          },
        },
      ],
    },

    // ========== ========== SurveyJS ========== ==========
    {
      path: "/survey-creator-page",
      name: "SurveyCreatorPage",
      component: () =>
        import("@/views/AdminManager/SurveyJS/SurveyCreatorPage"),
      meta: {
        roleUser: rolePermission[selectRolePermission],
        layout: "none",
      },
    },
    {
      path: "/survey-answer-page",
      name: "SurveyAnswerPage",
      component: () => import("@/views/AdminManager/SurveyJS/SurveyAnswerPage"),
      meta: {
        roleUser: rolePermission[selectRolePermission],
        layout: "none",
      },
    },

    // ========== ========== Partner ========== ==========
    {
      path: "",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "pm-marketing",
          path: "pm-marketing",
          component: () => import("@/views/AdminManager/Partner/PMMarketing"),
          meta: {
            roleUser: rolePermission[selectRolePermission],
          },
        },
      ],
    },
    // ========== ========== ========== ==========

    // ========== ========== Privacy Policy & Term Of Service ========== ==========
    {
      path: "/system-privacy-policy",
      name: "SystemPrivacyPolicy",
      component: () => import("@/views/AdminManager/SystemPrivacyPolicy"),
      meta: {
        roleUser: [],
        layout: "none",
      },
    },
    {
      path: "/system-term-of-service",
      name: "SystemTermOfService",
      component: () => import("@/views/AdminManager/SystemTermOfService"),
      meta: {
        roleUser: [],
        layout: "none",
      },
    },

    {
      path: "*",
      name: "error",
      redirect: "login",
      meta: {
        roleUser: [],
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  let role = store.state.defaultSystem.user;
  let roleName = "";
  if (role == null) {
    roleName = "unknown";
  } else {
    roleName = role.role;
  }

  if (!to.meta.roleUser[0]) {
    return next();
  }

  let checkRoleRoutes = to.meta.roleUser
    ? to.meta.roleUser.includes(roleName)
    : next({ name: "error" });

  if (checkRoleRoutes) {
    if (!checkPermission(to)) {
      return next({ name: "error" });
    }
    return next();
  } else {
    return next({ name: "error" });
  }
});

function checkPermission(to) {
  const user = store.state.defaultSystem.user;
  const role = JSON.parse(user.permissions);
  const checkRoleRoutes = to.meta.permission;
  let checkPermission = true;
  if (checkRoleRoutes) {
    checkPermission = role.some((item) => item == checkRoleRoutes);
  }
  return checkPermission;
}

export default router;
